import React from 'react';
import Language from './Language';
 
export default (props) => <Language {...props}/>;
